var Creator = function () {
}

Creator.prototype.createTravelSearchForm = function () {
  return {
    disableCityCountry: false,
    disableTourNum: false,
    tagName: 'Foreign',
    departureCity: {
      id: '',
      name: '',
      code: ''
    },
    arriveLine: {
      id: '',
      ttrLevel: '',
      name: ''
    },
    arriveCountry: {
      id: '',
      ttrLevel: '',
      name: ''
    },
    arriveCity: {
      id: '',
      ttrLevel: '',
      name: ''
    },
    arriveKeyword: '',
    tourNum: '',
    tourStatus: '1',
    stay: {
      checkinDate: Date.today().addDays(30).toString('yyyy/MM/dd'),
      checkoutDate: Date.today().addDays(160).toString('yyyy/MM/dd')
    }
  }
}

Creator.prototype.createHotelSearchForm = function () {
  return {
    place: {
      id: '',
      type: '',
      input: ''
    },
    stay: {
      checkinDate: Date.today().addMonths(1).toString('yyyy/MM/dd'),
      checkoutDate: Date.today().addMonths(1).addDays(1).toString('yyyy/MM/dd')
    },
    rooms: [{
      id: 1,
      adults: 2,
      children: []
    }]
  }
}

Creator.prototype.createState = function (options) {
  var state = {
    travelSearchForm: $.extend(true, {}, this.createTravelSearchForm()),
    hotelSearchForm: $.extend(true, {}, this.createHotelSearchForm()),
    customerSessionId: ''
  }

  var storage = JSON.parse(options.storage.getItem(options.key)) || {}
  var orderStorage = storage.order || {}

  var customerSessionId = orderStorage.customerSessionId || ''

  storage.order = {
    customerSessionId: customerSessionId
  }

  options.storage.setItem(options.key, JSON.stringify(storage))

  return state
}

export default new Creator()



// WEBPACK FOOTER //
// ./src/configs/store/modules/travel/creator.js